export default {
  default: {
    settings: 'Admin Settings',
    title: 'Organisation #{id}',
  },
}
